import DotAndDonutDiagram from './dot-and-doughnut-diagram';
export default DotAndDonutDiagram;
